export function formatCurrency(amount, curr = null, isCents = false) {
  amount = isCents ? amount * 0.01 : amount;
  return `${curr ? curr : '€'} ${(amount || 0).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ' ')}`;
}

export function randomInt(min, max) {
  return Math.floor(Math.random() * (max - min + 1)) + min;
}

export function formatMileage(x) {
  return x.toString()?.replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
}

export function formatDate(o, prop) {
  let date = o[prop];

  if (!date || !_.isString(date)) return o[prop];

  return _.reverse(
    date
      .split('T')
      .shift()
      .split('-'),
  ).join('-');
}

export function formatToTwoDecimalPlaces(value) {
  return value !== '' && !isNaN(value) ? Number(value).toFixed(2) : '';
}

export function limitToTwoDecimalPlaces(value) {
  if (value === null || value === undefined || value === '' || isNaN(value)) return value;

  let valueStr = value.toString();

  valueStr = valueStr?.replace(',', '.');

  if (!valueStr.includes('.')) {
    return value;
  }

  const [integerPart, decimalPart] = valueStr.split('.');

  if (decimalPart.length <= 2) {
    return value;
  }

  let resultString = `${integerPart}.${decimalPart.slice(0, 2)}`;

  return resultString;
}

export const isValidNumber = value => {
  if (typeof value === 'number' && isFinite(value)) return true;
  if (typeof value === 'string' && value.trim() !== '' && isFinite(value)) return true;
  return false;
};
